import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'response-dialog',
    templateUrl: 'response.component.html',
    styleUrls: ['./response.component.css'],
  })
  export class ResponseDialog {

    
    constructor(
        public dialogRef: MatDialogRef<ResponseDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        }

  }